<template>
  <div class="clue-transform-col-page">
    <special-head title="线索转化记录"> </special-head>

    <special-table :checkedParams="{ width: 38 }" :columns="columns" :data="dataList" :pagination="pagination" @paginationEvent="onPaginationEvent" :loading="loading">
      <!-- 线索名称 -->
      <template #companyName="{ row }">
        <jw-link style="word-break: break-all" @click="companyDetails(row)">{{ row.companyName }}</jw-link>
      </template>
      <!-- 跟进建议 插槽 -->
      <template #intentionality="{ row }">
        <template v-if="row?.custom?.intentionality">
          <xl-dot :title="row.custom.intentionality" :color="getIntentionalityColor(row.custom.intentionality)">
            {{ row.custom.intentionality }}
          </xl-dot>
        </template>
        <template v-else>-</template>
      </template>
      <!-- 跟进人插槽 -->
      <template #followUser="{ row }">
        <xl-avatar v-if="row?.followUser" :avatar="{ name: row?.followUserName || '', url: row?.followUserAvatar, id: row?.followUser }" :size="22" />
        <template v-else> - </template>
      </template>
      <!-- 线索渠道-->
      <template #from="{ row }">
        <template v-if="row?.custom?.from">{{ row?.custom?.from }}</template>
        <template v-else> - </template>
      </template>
      <!-- 创建人 -->
      <template #transformUser="{ row }">
        <xl-avatar v-if="row?.transformUser" :avatar="{ name: row?.transformUserName || '', url: row?.transformUserAvatar, id: row?.transformUser }" :size="22" />
        <template v-else> - </template>
      </template>
    </special-table>
  </div>
  <!-- 线索详情 -->
  <ly-detail ref="detailRef"></ly-detail>
</template>
<script>
import { clientService, opportunityService } from '@/api/';
// import { useRouter } from 'vue-router';
import { reactive, toRefs, inject, ref, computed, provide, onMounted } from 'vue';
import SpecialTable from '@/components/fh-detail/components/special-table/index.vue';
import SpecialHead from '@/components/fh-detail/components/special-head/index.vue';
import { useI18n } from 'vue-i18n';
import useFhSpecialTable from '@/hooks/fh-special-table';
export default {
  name: 'XlClueTransform',
  components: {
    SpecialTable,
    SpecialHead
  },
  setup() {
    const { t } = useI18n();
    const data = reactive({
      id: inject('detailParams').id,
      type: inject('detailParams').entity,
      colors: ['#37b41a', 'var(--color-text-2)', 'gold', 'orange', 'gray'], //跟进建议颜色
      clueId: null,
      loading: false
    });
    const detailRef = ref(); //线索详情
    // 表格头部标题
    const columns = [
      {
        title: t('线索'),
        colKey: 'companyName',
        slotName: 'companyName',
        width: 180
      },
      {
        title: t('线索跟进人'),
        colKey: 'followUser',
        slotName: 'followUser',
        width: 120
      },
      {
        title: t('跟进建议'),
        colKey: 'intentionality',
        slotName: 'intentionality',
        width: 120
      },
      {
        title: t('线索渠道'),
        colKey: 'from',
        slotName: 'from',
        width: 120
      },
      {
        title: t('转化人'),
        colKey: 'transformUser',
        slotName: 'transformUser',
        width: 120
      },
      {
        title: t('转化时间'),
        colKey: 'transformTime',
        width: 180
      }
    ];

    const requestParams = {
      id: data.id,
      type: data.type
    };

    const { pagination, onPaginationEvent, getDataList, dataList } = useFhSpecialTable(requestParams, data.type == 2 ? clientService.customerClueList.bind(clientService) : opportunityService.getClueList.bind(opportunityService));

    // 根据跟进建议获取对应的颜色
    const getIntentionalityColor = (intentionality) => {
      const colorMap = {
        待处理: 3,
        建议转化: 0,
        建议无效: 1,
        待定: 2
      };
      // 如果在映射表中找到对应值，返回对应颜色，否则返回默认颜色（索引4）
      return data.colors[colorMap[intentionality] ?? 4];
    };

    const companyDetails = (record) => {
      //跳转到线索弹窗
      data.clueId = record?.id;
      detailRef.value.openDialog();
    };
    provide('globalParams', {
      id: computed(() => data.clueId),
      entity: 1,
      viewId: -1
    });
    onMounted(() => {
      // 加载表格数据
      getDataList();
    });
    return {
      columns,
      getDataList,
      companyDetails,
      getIntentionalityColor,
      detailRef,
      dataList,
      pagination,
      onPaginationEvent,
      ...toRefs(data)
    };
  }
};
</script>
<style scoped lang="less">
@import './xl-clue-transform.less';
</style>
